import {
	BookClosed,
	CodeBranch,
	CodeFork,
	CreditCard,
	Home,
	ShieldAlert,
	Wallet,
	ChartLine,
	Tally,
} from '@primer-io/goat-icons'

export const menuItems = [
	{
		type: 'ITEM',
		icon: Home,
		title: 'Home',
		url: '/',
	},

	{
		type: 'ITEM',
		icon: Wallet,
		title: 'Payments',
		url: '/payments',
	},

	{
		type: 'ITEM',
		icon: CodeFork,
		title: 'Automation',
		url: '/automation',
	},
	{
		type: 'ITEM',
		icon: ChartLine,
		title: 'Observability',
		url: '/observability',
	},

	{
		type: 'ITEM',
		icon: Tally,
		title: 'Reconciliation',
		url: '/reconciliation',
	},

	{
		type: 'SEPARATOR',
	},

	// {
	// 	type: 'ITEM',
	// 	icon: Dollar,
	// 	title: 'Processors',
	// 	url: '/processors',
	// },

	{
		type: 'ITEM',
		icon: CreditCard,
		title: 'Payment Methods',
		url: '/payment-methods',
	},

	{
		type: 'ITEM',
		icon: ShieldAlert,
		title: 'Fraud Providers',
		url: '/fraud-providers',
	},

	{
		type: 'SEPARATOR',
	},

	{
		type: 'ITEM',
		icon: BookClosed,
		title: 'SDK Reference',
		url: '/sdk',
	},

	{
		type: 'ITEM',
		icon: CodeBranch,
		title: 'Changelog',
		url: '/changelog',
	},
]

export const SECONDARY_MENU_WIDTH = 260
export const PRIMARY_MENU_WIDTH = 60
export const PRIMARY_MENU_OPEN_WIDTH = 256

export const SIDE_MENU_WIDTH = PRIMARY_MENU_WIDTH + SECONDARY_MENU_WIDTH
